module.exports = __webpack_public_path__ + "static/media/green-bg.b2fbd830.svg";